import { render } from "./FormProducto.vue?vue&type=template&id=b611b83e&scoped=true"
import script from "./FormProducto.vue?vue&type=script&lang=js"
export * from "./FormProducto.vue?vue&type=script&lang=js"

import "./FormProducto.vue?vue&type=style&index=0&id=b611b83e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b611b83e"]])

export default __exports__